import Http from "../services/Providers/Http";

const ENDPOINTS = {
  GET_INVOICE: "/api/invoice/getInvoice",
  SET_USER: "/api/invoice/setUser",
  GET_BIN: "/api/invoice/binResult",
  DO_PAYMENT: "/api/invoice/doPayment",
  PRE_INVOICE: "/api/invoice/createInvoiceByGroup",
  UPDATE_PERMISSON: "/api/user/updatepermissions",
  TRANSACTIONS: "/api/staff/getMyTransactions",
  PAYMENT_TRANSACTIONS: "/api/staff/getPaymentTransactions",
  EXPORT_PAYMENT_TRANSACTIONS: "/api/staff/exportPaymentTransactions",
  GET_PRODUCTS: "/api/invoice/getProducts",
  SAVE_ADDRESS: "/api/invoice/saveUserAddress",
  GET_ADDRESS: "/api/invoice/getUserAddress",
  GET_CITIES: "/api/invoice/getCities",
  // KDM Ödeme Entegrasyonu
  INITIATE_KDM_PAYMENT: "/api/KdmPayment/initiate-payment",
  GET_KDM_PAYMENT_STATUS: "/api/KdmPayment/payment-status",
  PREPARE_KDM_INVOICE: "/api/KdmPayment/prepare-kdm-invoice",
  SEND_KDM_CALLBACK: "/api/KdmPayment/send-kdm-callback",
};

export default {
  getBanksAccounts: (payload, params) => {
    return Http.get(ENDPOINTS.BANK_ACCOUNTS_LIST, params, null, payload);
  },
  getInvoice: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_INVOICE, body, params, null, payload);
  },
  setUser: (body, payload, params) => {
    return Http.post(ENDPOINTS.SET_USER, body, params, null, payload);
  },
  getBin: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_BIN, body, params, null, payload);
  },
  doPayment: (body, payload, params) => {
    return Http.post(ENDPOINTS.DO_PAYMENT, body, params, null, payload);
  },
  prepeareInvoice: (body, payload, params) => {
    return Http.post(ENDPOINTS.PRE_INVOICE, body, params, null, payload);
  },
  do3DPayment: (body, payload, params) => {
    return Http.post(payload.AcsUrl, body, params, null, payload);
  },
  do3DPayment: (body, payload, params) => {
    return Http.post(payload.AcsUrl, body, params, null, payload);
  },
  getMyTransactions: (body, payload, params) => {
    return Http.post(ENDPOINTS.TRANSACTIONS, body, params, null, payload);
  },
  getPaymentTransactions: (body, payload, params) => {
    return Http.post(ENDPOINTS.PAYMENT_TRANSACTIONS, body, params, null, payload);
  },
  exportPaymentTransactions: () => {
    return ENDPOINTS.EXPORT_PAYMENT_TRANSACTIONS;
  },
  getProducts: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_PRODUCTS, body, params, null, payload);
  },
  saveUserAddress: (body, payload, params) => {
    return Http.post(ENDPOINTS.SAVE_ADDRESS, body, params, null, payload);
  },
  getUserAddress: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_ADDRESS, body, params, null, payload);
  },
  getCities: (payload, params) => {
    return Http.get(ENDPOINTS.GET_CITIES, params, null, payload);
  },
  // KDM Ödeme Entegrasyonu
  initiateKdmPayment: (body, payload, params) => {
    return Http.post(ENDPOINTS.INITIATE_KDM_PAYMENT, body, params, null, payload);
  },
  getKdmPaymentStatus: (applicationId, payload, params) => {
    return Http.get(`${ENDPOINTS.GET_KDM_PAYMENT_STATUS}/${applicationId}`, params, null, payload);
  },
  prepareKdmInvoice: (body, payload, params) => {
    return Http.post(ENDPOINTS.PREPARE_KDM_INVOICE, body, params, null, payload);
  },
  sendKdmCallback: (body, payload, params) => {
    return Http.post(ENDPOINTS.SEND_KDM_CALLBACK, body, params, null, payload);
  },
}; 